import { render, staticRenderFns } from "./AdminCompleted.vue?vue&type=template&id=05c30d42&scoped=true"
import script from "./AdminCompleted.vue?vue&type=script&lang=js"
export * from "./AdminCompleted.vue?vue&type=script&lang=js"
import style0 from "./AdminCompleted.vue?vue&type=style&index=0&id=05c30d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c30d42",
  null
  
)

export default component.exports